import _regeneratorRuntime from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.map";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(zip);

export function zip() {
  var _len,
      src,
      _key,
      iters,
      tuple,
      _iteratorNormalCompletion,
      _didIteratorError,
      _iteratorError,
      _iterator,
      _step,
      i,
      v,
      _args = arguments;

  return _regeneratorRuntime.wrap(function zip$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          for (_len = _args.length, src = new Array(_len), _key = 0; _key < _len; _key++) {
            src[_key] = _args[_key];
          }

          iters = src.map(function (s) {
            return s[Symbol.iterator]();
          });

        case 2:
          if (!true) {
            _context.next = 36;
            break;
          }

          tuple = [];
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 7;
          _iterator = iters[Symbol.iterator]();

        case 9:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 18;
            break;
          }

          i = _step.value;
          v = i.next();

          if (!v.done) {
            _context.next = 14;
            break;
          }

          return _context.abrupt("return");

        case 14:
          tuple.push(v.value);

        case 15:
          _iteratorNormalCompletion = true;
          _context.next = 9;
          break;

        case 18:
          _context.next = 24;
          break;

        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](7);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 24:
          _context.prev = 24;
          _context.prev = 25;

          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }

        case 27:
          _context.prev = 27;

          if (!_didIteratorError) {
            _context.next = 30;
            break;
          }

          throw _iteratorError;

        case 30:
          return _context.finish(27);

        case 31:
          return _context.finish(24);

        case 32:
          _context.next = 34;
          return tuple;

        case 34:
          _context.next = 2;
          break;

        case 36:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[7, 20, 24, 32], [25,, 27, 31]]);
}
/**
 * @deprecated renamed to `zip`
 */

export var tuples = zip;